<template>
  <div class="lookbook-dashboard">
    <div class="back-btn button-slide-hover" @click="returnToDashboard">
      <svg xmlns="http://www.w3.org/2000/svg">
        <image xlink:href="/images/icons/chevron-left.svg" />
      </svg>
      BACK
    </div>
    <div class="lookbook-dashboard-heading">
      APS Shortlists
    </div>
    <div class="lookbook-dashboard-subheading">
      View our APS Shortlists curated by our team and industry wide location scouts.
    </div>
    <loader :loading="loading" :fixed="true"></loader>
    <template v-if="!loading">
      <div class="lookbook-blocks">
        <div class="lookbook-card" v-for="shortlist in shortlists" :key="shortlist.id">
          <div class="lookbook-card-left">
            <div v-if="shortlist.listings.length" class="lookbook-card-image"
            :style="{'background': 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 43.81%, #000 100%), url('+shortlist.listings[0].thumbnail_url+') center / cover no-repeat, lightgray 50% / cover no-repeat'}"
            >
              <div class="share-button interactive" v-if="shortlist.listings.length" @click="openShareModal(shortlist)">
                <svg xmlns="http://www.w3.org/2000/svg">
                  <image xlink:href="/images/icons/export.svg" />
                </svg>
              </div>
              <div class="lookbook-aps-logo"><img src="/images/icons/logo-full-v2.svg"/></div>
            </div>
          </div>
          <div class="lookbook-card-right">
            <div class="lookbook-listings-count">
              {{ shortlist.listings.length }} listings
            </div>
            <div class="lookbook-shortlist-title">
              {{ shortlist.label }}
            </div>
            <div class="lookbook-shortlist-view button-slide-hover interactive" @click="viewShortlist(shortlist)">
              View
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>

</template>

<script>
export default {
  data() {
    return {
      loading: false,
      shortlists: []
    }
  },
  methods: {
    getLookbooks() {
      this.loading = true;
      axios.get(`/api/account/shortlists/public`)
        .then((response) => {
          this.shortlists = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        })
    },
    returnToDashboard() {
      this.$store.commit('findspace/setSubpage', { subpage: 'home', item: null })
    },
    viewShortlist(shortlist) {
      this.$store.commit('findspace/setSubpage', { subpage: 'view', item: shortlist })
    },
    openShareModal(shortlist) {
      this.$store
        .dispatch("modals/show", {
          type: "shortlist-share",
          maskCanDismiss: false,
          headless: true,
          narrow: true,
          data: {
            shortlist: shortlist
          }
        });
    },
  },
  mounted() {
    this.getLookbooks();
  },
}
</script>
